import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [ContactUsComponent],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class ContactUsModule { }
